import React, { useState, useEffect } from "react"
import "./index.scss"
import { Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const CardContent = ({ contentType, cardAlignment, cardColor, postData }) => {
  const [intro, setIntro] = useState('');

  const {
    slug,
    title,
    introText,
    datePosted,
    externalLink,
    featuredImage,
    reportSubtitle,
    typeOfResource,
  } = postData

  const selectIntroCard = (contentType) => {
    switch (contentType) {
      case 'resource':
        return setIntro(reportSubtitle);
      case 'report':
        return setIntro(reportSubtitle);
      default:
        return setIntro(introText);
    }
  }

  useEffect(() => {
    selectIntroCard(contentType);
  }, [])
  

  const img = getImage(featuredImage)
  return (
    <div
      className={`card ${
        cardAlignment === "horizontal" ? "flex-row" : "flex-column"
      }`}
    >
      {featuredImage && (
        <div className="card__image">
          <GatsbyImage image={img} alt="" />
        </div>
      )}

      <div className="card__data" style={{ backgroundColor: cardColor }}>
        {!(
          contentType === "fiscally_sponsored_project" ||
          cardAlignment === "vertical"
        ) && (
          <div className="row  align-items-center">
            <span className="card__content-type" style={{ color: cardColor }}>
              {contentType === "resource"
                ? typeOfResource.replace("-", " ")
                : contentType}
            </span>
            <span className="card__date">{datePosted}</span>
          </div>
        )}

        <h5 className="card__title text-white">{title}</h5>

        <p className="card__content">
          {
              intro?.substring(0,120)
          }
          {
            (intro?.length < 120 || intro?.length === 0) ? '' : '...'
          }
        </p>

        {externalLink && (
          <a href={externalLink} rel="noopener noreferrer" target="_blank">
            Read more
          </a>
        )}
        {slug && <Link to={`${contentType === 'project' ? '/our-work' : ''}/${contentType}s/${slug}`}>Read More</Link>}
      </div>
    </div>
  )
}

/**
 * Returns Item Layout
 */
export default function SliderCard({
  contentType,
  postData,
  cardColor,
  cardAlignment,
}) {
  const { slug, externalLink } = postData

  return (
    <>
      {externalLink && (
        <a href={externalLink}>
          <CardContent
            contentType={contentType}
            cardAlignment={cardAlignment}
            cardColor={cardColor}
            postData={postData}
          />
        </a>
      )}
      {slug && (
        <Link to={`${contentType === 'project' ? '/our-work' : ''}/${contentType}s/${slug}`}>
          <CardContent
            contentType={contentType}
            cardAlignment={cardAlignment}
            cardColor={cardColor}
            postData={postData}
          />
        </Link>
      )}
    </>
  )
}
